import React, { useState, useEffect } from 'react';
import { Container, Progress, Button } from 'reactstrap';
import WelcomeStep from './WelcomeStep';
import ProfileStep from './ProfileStep';
import DashboardTourStep from './DashboardTourStep';
import FirstActionStep from './FirstActionStep';
import { useNavigate } from 'react-router-dom';
import { PostData } from '../../services/api';
import logodark from '../../assets/images/logo.png';
import './onboarding.css';

const OnboardingWizard = ({ userPlan, onComplete }) => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [profileData, setProfileData] = useState({});
  const totalSteps = 4;

  // Agregar clase al body para ocultar scroll
  useEffect(() => {
    document.body.classList.add('onboarding-active');
    return () => {
      document.body.classList.remove('onboarding-active');
    };
  }, []);

  const handleComplete = async (redirectTo = '/dashboard') => {
    try {
      await PostData('/users/complete-onboarding', {
        onboardingCompleted: true,
        ...profileData
      });
      
      onComplete();
      navigate(redirectTo);
    } catch (error) {
      console.error('Error completing onboarding:', error);
      navigate(redirectTo);
    }
  };

  const steps = [
    {
      title: "Bienvenida",
      component: <WelcomeStep 
        plan={userPlan} 
        onNext={() => setCurrentStep(2)} 
      />
    },
    {
      title: "Perfil",
      component: <ProfileStep 
        onComplete={(data) => {
          setProfileData(data);
          setCurrentStep(3);
        }}
        onBack={() => setCurrentStep(1)}
      />
    },
    {
      title: "Tour",
      component: <DashboardTourStep 
        onNext={() => setCurrentStep(4)}
        onBack={() => setCurrentStep(2)}
      />
    },
    {
      title: "Primera acción",
      component: <FirstActionStep 
        onComplete={handleComplete}
        onBack={() => setCurrentStep(3)}
      />
    }
  ];

  return (
    <div className="onboarding-fullscreen">
      <div className="onboarding-header">
        <div className="container">
          <div className="onboarding-header-content">
            <div className="onboarding-logo">
              <img src={logodark} alt="Claryo" style={{height: '40px'}} />
            </div>
            <div className="onboarding-progress-section">
              <span className="step-indicator">
                {steps[currentStep - 1].title} • {currentStep} de {totalSteps}
              </span>
              <Progress 
                value={(currentStep / totalSteps) * 100} 
                color="primary"
                className="onboarding-progress-bar"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="onboarding-body">
        <Container className="onboarding-container">
          <div className="onboarding-content-wrapper">
            {steps[currentStep - 1].component}
          </div>
        </Container>
      </div>

      <div className="onboarding-footer">
        <div className="container">
          <div className="onboarding-footer-content">
            <div className="onboarding-steps-dots">
              {steps.map((_, index) => (
                <div
                  key={index}
                  className={`step-dot ${index + 1 === currentStep ? 'active' : ''} ${index + 1 < currentStep ? 'completed' : ''}`}
                />
              ))}
            </div>
            <div className="onboarding-footer-text">
              <span>Claryo - La plataforma que ejecuta tus ventas en automático</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingWizard;

